import globals from '../../../../scripts/modules/globals';
import dropdown from './dropdown';
import options from './options';

export default function () {
	dropdown();
	options();
}
